import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";
import { clientProjects as staticClientProjects } from "../content/clientProjects";

const PROJECTS_TABLE = "client_projects";
const FILES_TABLE = "client_project_files";
const UPDATES_TABLE = "client_project_updates";

const mapFileRecord = (record) => ({
    id: record.id,
    label: record.label,
    fileType: record.file_type ?? record.fileType ?? "other",
    note: record.note ?? null,
    sizeLabel: record.size_label ?? record.sizeLabel ?? null,
    storageBucket: record.storage_bucket ?? record.storageBucket ?? null,
    storagePath: record.storage_path ?? record.storagePath ?? null,
    version: record.version ?? null,
    createdAt: record.created_at ?? record.createdAt ?? null,
});

const mapUpdateRecord = (record) => ({
    id: record.id,
    title: record.title,
    body: record.body ?? "",
    status: record.status ?? "bilgi",
    postedAt: record.posted_at ?? record.postedAt ?? null,
});

const mapProjectRecord = (record) => ({
    id: record.id,
    title: record.title,
    status: record.status ?? "",
    summary: record.summary ?? "",
    kickoffDate: record.kickoff_date ?? record.kickoffDate ?? null,
    deliveryDate: record.delivery_date ?? record.deliveryDate ?? null,
    updatedAt: record.updated_at ?? record.updatedAt ?? null,
    files: (record.files ?? record.client_project_files ?? []).map(mapFileRecord),
    updates: (record.updates ?? record.client_project_updates ?? []).map(mapUpdateRecord),
});

const ensureSupabase = () => {
    if (!isSupabaseConfigured || !supabase) {
        throw new Error(
            "Supabase yapılandırılmadan müşteri projeleri API'sine erişilemez. Lütfen .env içinde REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY değerlerini tanımlayın."
        );
    }
};

export const fetchClientProjects = async () => {
    if (!isSupabaseConfigured || !supabase) {
        return staticClientProjects;
    }

    const { data, error } = await supabase
        .from(PROJECTS_TABLE)
        .select(
            `id, title, status, summary, kickoff_date, delivery_date, updated_at,
       files:${FILES_TABLE} (id, label, file_type, note, size_label, storage_bucket, storage_path, version, created_at),
       updates:${UPDATES_TABLE} (id, title, body, status, posted_at)`
        )
        .order("updated_at", { ascending: false });

    if (error) {
        console.error("Supabase fetchClientProjects error", error);
        throw error;
    }

    return (data ?? []).map(mapProjectRecord);
};

export const fetchClientProjectById = async (projectId) => {
    if (!isSupabaseConfigured || !supabase) {
        return staticClientProjects.find((project) => project.id === projectId) ?? null;
    }

    const { data, error } = await supabase
        .from(PROJECTS_TABLE)
        .select(
            `id, title, status, summary, kickoff_date, delivery_date, updated_at,
       files:${FILES_TABLE} (id, label, file_type, note, size_label, storage_bucket, storage_path, version, created_at),
       updates:${UPDATES_TABLE} (id, title, body, status, posted_at)`
        )
        .eq("id", projectId)
        .maybeSingle();

    if (error) {
        console.error("Supabase fetchClientProjectById error", error);
        throw error;
    }

    return data ? mapProjectRecord(data) : null;
};

export const createSignedAssetUrl = async ({ bucket, path, expiresIn = 900 }) => {
    ensureSupabase();
    const bucketRef = bucket || "project-assets";
    if (!path) {
        throw new Error("İndirme linki oluşturmak için storage_path değeri gereklidir.");
    }

    const { data, error } = await supabase.storage.from(bucketRef).createSignedUrl(path, expiresIn, {
        download: true,
    });

    if (error) {
        console.error("Supabase createSignedAssetUrl error", error);
        throw error;
    }

    return data?.signedUrl ?? null;
};
